module.exports = __webpack_public_path__ + "img/sheet_user.0bd0dae0.svg";